import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  bulkInsertWardrobe,
  bulkUploadWardrobe,
  createWardrobe,
  deleteWardrobe,
  getAllCategorySubcategory,
  getUserById,
  getUserOccasions,
  updateWardrobe,
} from "../../apis";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import actions from "../../actions";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "./wardrobes.css";
import { Pagination } from "@mui/material";
import BulkUploadStatusModal from "../../components/BulkUploadStatusModal";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

export const ColorMapping = {
  '#000000': 'Black',
  '#FFFFFF': 'White',
  '#808080': 'Grey',
  '#8B4513': 'Brown',
  '#EDE8D0': 'Beige',
  '#FF0000': 'Red',
  '#FFA500': 'Orange',
  '#FFFF00': 'Yellow',
  '#008000': 'Green',
  '#0000FF': 'Blue',
  '#8A2BE2': 'Violet',
  '#FFC0CB': 'Pink',
  '#FF00FF': 'Magenta',
  '#E6E6FA': 'Lavender',
  '#98FF98': 'Mint',
  '#FFDAB9': 'Peach',
  '#FFF5EE': 'Cream',
  '#FFD700': 'Gold',
  '#C0C0C0': 'Silver',
};

const WardrobePage = ({
  stopLoadingRequest,
  startLoadingRequest,
  activateModal,
}) => {
  // Store the full data instead of only paginated items
  const [allWardrobes, setAllWardrobes] = useState([]);
  // State for search term
  const [searchTerm, setSearchTerm] = useState("");

  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { id } = useParams(); // user id
  const [selectedWardrobe, setSelectedWardrobe] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [uploadingModal, setUploadingModal] = useState(false);
  // Basic fields
  const [name, setName] = useState("");
  const [image, setImage] = useState("");
  const [brand, setBrand] = useState("");
  const [description, setDescription] = useState("");

  const [fullScreenImage, setFullScreenImage] = useState(null);

  // Additional fields
  const [wardrobeState, setWardrobeState] = useState("");
  const [primaryColorName, setPrimaryColorName] = useState("");
  const [primaryColorCode, setPrimaryColorCode] = useState("");
  const [secondaryColorName, setSecondaryColorName] = useState("");
  const [secondaryColorCode, setSecondaryColorCode] = useState("");
  const [size, setSize] = useState("");
  const [dateOfPurchase, setDateOfPurchase] = useState("");
  const [price, setPrice] = useState("");
  const [printStyle, setPrintStyle] = useState("");
  const [textureStyle, setTextureStyle] = useState("");
  const [collarStyle, setCollarStyle] = useState("");
  const [sleeveLength, setSleeveLength] = useState("");
  const [instructions, setInstructions] = useState("");
  const [tags, setTags] = useState("");
  const [occasion, setOccasion] = useState([]);
  const [wearingSeason, setWearingSeason] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10); // How many rows to show per page
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [userData, setUserData] = useState(null);
  const [page, setPage] = useState(0);
  const [uploadedData, setUploadedData] = useState([]);
  // For category select inputs
  const [categoryId, setCategoryId] = useState("");
  const [subcategoryId, setSubcategoryId] = useState("");
  const [userOccasion,setUserOccasionData]=useState([])
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const dropdownRefs = useRef([]);
   const adminDetails=JSON.parse(localStorage.getItem("userDetails"))
  const userManagementPermissions=adminDetails?.role?.userManagementPermissions||[]
  const fileInputRef = useRef(null);

  // Function to handle pagination logic using slice
  const paginateItems = (items) => {
    const indexOfLastItem = currentPage * rowsPerPage;
    const indexOfFirstItem = indexOfLastItem - rowsPerPage;
    return items.slice(indexOfFirstItem, indexOfLastItem);
  };

  // Fetch wardrobes and related data from the user details API
  const fetchWardrobes = useCallback(async () => {
    try {
      startLoadingRequest();
      const apiResponse = await getUserById(id);
      const CatapiResponse = await getAllCategorySubcategory("category", page + 1, 20);
      const SubCatapiResponse = await getAllCategorySubcategory("subcategory", page + 1, 200);
      
      const data = apiResponse?.data?.data;
      const PreferedCategory = CatapiResponse?.data?.data?.categories.filter((el) => el.stylePreference === (data.stylePreference==="Unisex" ? "Women" : data.stylePreference));
      const PreferedSubCategory = SubCatapiResponse?.data?.data?.subcategories
      const preferredCategoryIds = PreferedCategory.map(cat => cat._id);
      const filteredSubcategories = data.stylePreference==="Unisex" ? PreferedSubCategory : PreferedSubCategory.filter(subcat => 
        preferredCategoryIds.includes(subcat.categoryId)
      );
      // Store the full list of wardrobe items
      const fullWardrobes = data?.wardrobes || [];
      setAllWardrobes(fullWardrobes);
      setUserData(data);
      // Set categories and subcategories
      setCategories([...data?.categories, ...PreferedCategory] || []);
      setSubCategories([...data?.subCategory, ...filteredSubcategories] || []);
    } catch (error) {
      setAllWardrobes([]);
    } finally {
      stopLoadingRequest();
    }
  }, [startLoadingRequest, stopLoadingRequest, id, categoryId, currentPage]);

  const getOccasions = async () => {
    try {
      startLoadingRequest();
      const apiResponse = await getUserOccasions(id);
      const data = apiResponse?.data?.data;
      setUserOccasionData(data)
    } catch (error) {
      setAllWardrobes([]);
    } finally {
      stopLoadingRequest();
    } 
  }
  useEffect(() => {
    fetchWardrobes();
    getOccasions()
  }, [fetchWardrobes]);

  // Reset to first page when search term changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const handleAddWardrobe = () => {
    setSelectedWardrobe("");
    // Reset all fields
    setName("");
    setImage("");
    setBrand("");
    setDescription("");
    setWardrobeState("");
    setPrimaryColorName("");
    setPrimaryColorCode("");
    setSecondaryColorName("");
    setSecondaryColorCode("");
    setSize("");
    setDateOfPurchase("");
    setPrice("");
    setPrintStyle("");
    setTextureStyle("");
    setCollarStyle("");
    setSleeveLength("");
    setInstructions("");
    setTags("");
    setOccasion("");
    setWearingSeason("");
    setCategoryId("");
    setSubcategoryId("");
    setIsModalOpen(true);
  };

  // Helper function to convert "dd-MM-yyyy" to "yyyy-MM-dd"
  const convertDateToISO = (dateStr) => {
    if (!dateStr) return "";
    const parts = dateStr.split("-");
    if (parts.length === 3) {
      const [day, month, year] = parts;
      // Ensure day and month are two digits
      const formattedDay = day.padStart(2, "0");
      const formattedMonth = month.padStart(2, "0");
      return `${year}-${formattedMonth}-${formattedDay}`;
    }
    return dateStr; // return unchanged if not in expected format
  };

  const handleEditWardrobe = (wardrobe) => {
    setSelectedWardrobe(wardrobe._id);
    setName(wardrobe.name);
    setImage(wardrobe.image);
    setBrand(wardrobe.brand);
    setDescription(wardrobe.description);
    setWardrobeState(wardrobe.state);
    setPrimaryColorName(wardrobe.primaryColorName);
    setPrimaryColorCode(wardrobe.primaryColorCode);
    setSecondaryColorName(wardrobe.secondaryColorName);
    setSecondaryColorCode(wardrobe.secondaryColorCode);
    setSize(wardrobe.size);
    setDateOfPurchase(convertDateToISO(wardrobe.dateOfPurchase));
    setPrice(wardrobe.price);
    setPrintStyle(wardrobe.printStyle);
    setTextureStyle(wardrobe.textureStyle);
    setCollarStyle(wardrobe.collarStyle);
    setSleeveLength(wardrobe.sleeveLength);
    setInstructions(Array.isArray(wardrobe.instructions) ? wardrobe.instructions.join(", ") : "");
    setTags(Array.isArray(wardrobe.tags) ? wardrobe.tags.join(", ") : "");
    // setOccasion(wardrobe.occasion);
    setWearingSeason(Array.isArray(wardrobe.wearingSeason) ? wardrobe.wearingSeason.join(", ") : "");
    setCategoryId(wardrobe.categoryId);
    setSubcategoryId(wardrobe.subcategoryId);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const createNewWardrobe = async () => {
    try {
      const formData = {
        userId: id,
        name,
        image,
        brand,
        description,
        state: wardrobeState,
        primaryColorName,
        primaryColorCode,
        secondaryColorName,
        secondaryColorCode,
        size,
        dateOfPurchase,
        price,
        printStyle,
        textureStyle,
        collarStyle,
        sleeveLength,
        instructions: instructions.split(",").map((i) => i.trim()).filter((i) => i),
        tags: tags.split(",").map((t) => t.trim()).filter((t) => t),
        categoryId,
        subcategoryId,
        // occasion,
        wearingSeason: wearingSeason.split(",").map((w) => w.trim()).filter((w) => w),
      };

      const response = await createWardrobe(formData);
      if (response && response.data) {
        await fetchWardrobes();
        toast.success("Wardrobe item created successfully!");
        closeModal();
      } else {
        throw new Error("Invalid response from server");
      }
    } catch (error) {
      toast.error("Error creating wardrobe item. Please try again.");
    } finally {
      stopLoadingRequest();
    }
  };

  const updateExistingWardrobe = async () => {
    try {
      const formData = {
        userId: id,
        wardrobeId: selectedWardrobe,
        name,
        image,
        brand,
        description,
        state: wardrobeState,
        primaryColorName,
        primaryColorCode,
        secondaryColorName,
        secondaryColorCode,
        size,
        dateOfPurchase,
        price,
        printStyle,
        textureStyle,
        collarStyle,
        sleeveLength,
        instructions: instructions.split(",").map((i) => i.trim()).filter((i) => i),
        tags: tags.split(",").map((t) => t.trim()).filter((t) => t),
        categoryId,
        subcategoryId,
        occasion,
        wearingSeason: wearingSeason.split(",").map((w) => w.trim()).filter((w) => w),
      };

      const response = await updateWardrobe(formData);
      if (response && response.data) {
        await fetchWardrobes();
        toast.success("Wardrobe item updated successfully!");
        closeModal();
      } else {
        throw new Error("Invalid response from server");
      }
    } catch (error) {
      toast.error("Error updating wardrobe item. Please try again.");
    } finally {
      stopLoadingRequest();
    }
  };

  const handleDeleteWardrobe = async (wardrobeId) => {
    try {
        const response = await deleteWardrobe(wardrobeId, id);
        if (response && response.data) {
          await fetchWardrobes();
          toast.success("Wardrobe item deleted successfully!");
        } else {
          throw new Error("Invalid response from server");
        }
    } catch (error) {
      toast.error("Error deleting wardrobe item. Please try again.");
    } finally {
      stopLoadingRequest();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    startLoadingRequest();
    if (selectedWardrobe) {
      updateExistingWardrobe();
    } else {
      createNewWardrobe();
    }
  };

  const toggleDropdown = (index) => {
    setDropdownOpen(dropdownOpen === index ? null : index);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefs.current &&
        !dropdownRefs.current.some((ref) => ref && ref.contains(event.target))
      ) {
        setDropdownOpen(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  // Helper: get category name from ID
  const getCategoryName = (catId) =>
    categories?.find((cat) => cat._id === catId)?.name || catId;
  const getSubCategoryName = (subId) =>
    subCategories.find((sub) => sub._id === subId)?.name || subId;
  // console.log({subCategories})

  const handleUpdateUploadedItem = async (updatedItem) => {
    setUploadedData(prev =>
      prev.map(item => item._id === updatedItem._id ? { ...item, ...updatedItem } : item)
    );
    // toast.success(`Updated item: ${updatedItem.name}`);
    // await fetchWardrobes();
  };

  const handleSaveAllUploadedItems = async (itemsToSave) => {
    if(isLoading||isSaving) return

    setIsSaving(true)
    try {
      const userId = id; // from useParams or userData
      const wardrobePayload = itemsToSave.map(item => ({
        image: item.image,
        name: item.name,
        description: item.description,
        brand: item.brand,
        state: item.state,
        primaryColorName: item.primaryColorName,
        secondaryColors: item.secondaryColors || [],
        primaryColorCode: item.primaryColorCode,
        secondaryColorCode: item.secondaryColorCode,
        secondaryColorName: item.secondaryColorName,
        size: item.size,
        dateOfPurchase: item.dateOfPurchase,
        price: item.price ? Number(item.price) : undefined,
        printStyle: item.printStyle,
        textureStyle: item.textureStyle,
        collarStyle: item.collarStyle,
        sleeveLength: item.sleeveLength,
        instructions: Array.isArray(item.instructions)
          ? item.instructions
          : typeof item.instructions === 'string'
            ? item.instructions.split(',').map(i => i.trim()).filter(Boolean)
            : [],
        tags: Array.isArray(item.tags)
          ? item.tags
          : typeof item.tags === 'string'
            ? item.tags.split(',').map(t => t.trim()).filter(Boolean)
            : [],
        isRetired: item.isRetired === 'Yes' || item.isRetired === true,
        categoryId: item.categoryId,
        subcategoryId: item.subcategoryId,
        userId: userId,
        // occasion: item.occasion,
        wearingSeason: Array.isArray(item.wearingSeason)
          ? item.wearingSeason
          : typeof item.wearingSeason === 'string'
            ? item.wearingSeason.split(',').map(s => s.trim()).filter(Boolean)
            : [],
      }));
      const payload = {
        items: wardrobePayload,
        userId: userId,
        stylePreference: userData?.stylePreference,
      }
      
      // console.log('Payload to send:', payload);
      
      const response = await bulkInsertWardrobe(payload);
      // console.log("response",response)
      if(response && response.data){
        toast.success("All uploaded items saved successfully!");
        await fetchWardrobes();
        setUploadingModal(false);
        setUploadedData([]);
      }else{
        throw new Error("Invalid response from server");
      }
      
    } catch (error) {
      console.error("Error saving all items:", error);
      toast.error("Failed to save all items.");
    } finally {
      setIsSaving(false)
      stopLoadingRequest();
    }
  };

  const handleCloseUploadingModal = () => {
    setUploadingModal(false);
    setUploadedData([]); // Clear uploaded data when modal closes
  };

  // Filter wardrobes based on search term (searching name, description, and brand)
  const filteredWardrobes = allWardrobes.filter(
    (item) =>
      (item.name || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.description || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.brand || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item?.categoryName || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item?.subcategoryName || "").toLowerCase().includes(searchTerm.toLowerCase())
  );
  

  const computedTotalPages = Math.ceil(filteredWardrobes.length / rowsPerPage);
  const displayedWardrobes = paginateItems(filteredWardrobes);

  const allowedExtensions = ['.jpg', '.jpeg', '.png', '.webp', '.heic'];

  const handleBulkUpload = () => {
    fileInputRef.current?.click();
  };

  const handleFileSelection = async(event) => {
    const files = Array.from(event.target.files);
    
    if (files.length === 0) {
      return;
    }

    if (files.length > 10) {
      toast.error(`You can only upload a maximum of 10 images at once.`);
      // Reset the file input
      event.target.value = '';
      return;
    }

    // Filter files by allowed extensions
    const validFiles = files.filter(file => {
      const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
      const isValid = allowedExtensions.includes(fileExtension);
      console.log(`File: ${file.name}, Extension: ${fileExtension}, Valid: ${isValid}`);
      return isValid;
    });

    const invalidFiles = files.filter(file => {
      const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
      return !allowedExtensions.includes(fileExtension);
    });

    if (invalidFiles.length > 0) {
      toast.error(`${invalidFiles.length} file(s) have invalid extensions. Allowed: ${allowedExtensions.join(', ')}`);
      console.log('Invalid files:', invalidFiles.map(f => f.name));
    }

          if (validFiles.length > 0) {
        try {
          setIsLoading(true);
          setUploadingModal(true);
          toast.info(`Uploading ${validFiles.length} image(s)...`);
          if(userData){
            const formData = new FormData();
          validFiles.forEach(file => {
            formData.append('file', file);
          });
          formData.append('userId', id);
          formData.append('stylePreference', userData?.stylePreference);


          const response = await bulkUploadWardrobe(formData);
          
          if (response && response.data) {
            setUploadedData(response.data?.items);
          } else {
            throw new Error("Invalid response from server");
          }
          }
          
        } catch (error) {
          console.error('Bulk upload error:', error);
          const errorMessage = error.response?.data?.message || error.message || "Failed to upload images";
          toast.error(`Upload failed: ${errorMessage}`);
        } finally {
          setIsLoading(false);
        }
        
      } else if (files.length > 0) {
      toast.error('No valid image files selected.');
    }

    // Reset the file input
    event.target.value = '';
  };

  const downloadFormat = () => {
    const link = document.createElement("a");
    link.href = "/WardrobeItemFormat.xlsx";
    link.download = "WardrobeItemFormat.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };



  return (
    <div className="wardrobe-page">
      <div
        className="table-header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <h2>
          {searchTerm.trim() === "" ? (
            "Wardrobe Items"
          ) : displayedWardrobes.length > 0 ? (
            <>
              Results for <span className="highlight">{searchTerm}</span>
            </>
          ) : (
            <>0 Wardrobe Found!</>
          )}
        </h2>
        <div style={{ display: "flex", gap: "10px" }}>
          {userManagementPermissions.includes("bulkUpload") && (
            <div>
              <button
                disabled={!userData?.isAccess}
                style={{
                  backgroundColor: userData?.isAccess ? "#000" : "#999",
                  color: "#fff",
                  padding: "10px 20px",
                  borderRadius: "5px",
                  border: "none",
                  cursor: userData?.isAccess ? "pointer" : "not-allowed",
                  opacity: userData?.isAccess ? 1 : 0.6,
                  transition: "all 0.2s ease",
                }}
                onClick={handleBulkUpload}
              >
                Bulk Upload
              </button>
            </div>
          )}
          {/* <div style={{display:"flex",flexDirection:"row",gap:"15px"}}>
          <button style={{ border: "1px solid black", color: "black", borderRadius: "4px" }}>Upload Items</button>
          <button onClick={downloadFormat} style={{ border: "1px solid black", color: "black", borderRadius: "4px" }}>Download Format</button>
        </div> */}
          <div className="search-container">
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      </div>
      {userData?.isAccess ? (
        <div
          className="table-container"
          style={{ marginTop: "-20px", height: "65vh" }}
        >
          <table className="wardrobe-table" id="wardrobe-table-color">
            <thead>
              <tr>
                <th>#</th>
                <th>Image</th>
                <th>Name</th>
                <th>Description</th>
                <th>Category</th>
                <th>Sub Category</th>
                <th>Item Usage</th>
                <th>Item Worn</th>
                <th>Brand</th>
                <th>Is Retired</th>
                <th>Primary Color</th>
                <th>Secondary Color</th>
                <th>Size</th>
                <th>Date Of Purchase</th>
                <th>Price</th>
                <th>Print Style</th>
                <th>Texture Style</th>
                <th>Collar Style</th>
                <th>Sleeve Length</th>
                <th>Instructions</th>
                <th>Tags</th>
                <th>Occasion</th>
                <th>State</th>
                <th>Wearing Season</th>
                <th>Created At</th>
                <th>Updated At</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {displayedWardrobes.map((item, index) =>
                item ? (
                  <tr key={item._id}>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                    <td>
                      <img
                        src={item.image}
                        alt={item.name}
                        className="wardrobe-image"
                        onClick={() => setFullScreenImage(item.image)}
                      />
                    </td>
                    <td>{item.name}</td>
                    <td>{item.description}</td>
                    <td>{item.categoryName}</td>
                    <td>{item.subcategoryName}</td>
                    <td>{item?.totalUsageInOutfit || 0}</td>
                    <td>{item?.totalWornCount || 0}</td>
                    <td>{item.brand}</td>
                    <td>{item.isRetired ? "Yes" : "No"}</td>
                    <td>{item.primaryColorName}</td>
                    <td>{item.secondaryColorName}</td>
                    <td>{item.size}</td>
                    <td>{item.dateOfPurchase}</td>
                    <td>{item.price !== null ? item.price : "-"}</td>
                    <td>{item.printStyle}</td>
                    <td>{item.textureStyle}</td>
                    <td>{item.collarStyle}</td>
                    <td>{item.sleeveLength}</td>
                    <td>
                      {Array.isArray(item.instructions)
                        ? item.instructions.join(", ")
                        : item.instructions}
                    </td>
                    <td>
                      {Array.isArray(item.tags)
                        ? item.tags.join(", ")
                        : item.tags}
                    </td>
                    <td>
                      {Array.isArray(item.Occasion) && item.Occasion.length > 0
                        ? item.Occasion.map((occ) => occ.name).join(", ")
                        : "—"}
                    </td>

                    <td>{item.state}</td>
                    <td>
                      {Array.isArray(item.wearingSeason)
                        ? item.wearingSeason.join(", ")
                        : item.wearingSeason}
                    </td>
                    <td>{new Date(item.createdAt).toLocaleDateString()}</td>
                    <td>{new Date(item.updatedAt).toLocaleDateString()}</td>
                    <td style={{ display: "flex", gap: "10px" }}>
                      <EditIcon
                        style={{ cursor: "pointer", color: "#3f51b5" }}
                        onClick={() => handleEditWardrobe(item)}
                      />

                      <DeleteIcon
                        style={{ cursor: "pointer", color: "red" }}
                        onClick={() => handleDeleteWardrobe(item._id)}
                      />
                    </td>
                  </tr>
                ) : null
              )}
            </tbody>
          </table>
          <div className="pagination-container">
            <Pagination
              count={computedTotalPages} // Total number of pages based on filtered data
              page={currentPage} // Current page number
              onChange={handlePageChange} // Handle page change
              color="primary"
            />
          </div>
        </div>
      ) : (
        <div
          style={{
            width: "100%",
            height: "10rem",
            color: "red",
            fontSize: "15px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          You do not have permission to access user wardrobes
        </div>
      )}

      {fullScreenImage && (
        <div
          className="full-screen-overlay"
          onClick={() => setFullScreenImage(null)}
        >
          <img
            src={fullScreenImage}
            alt="Full Screen"
            className="full-screen-image"
          />
        </div>
      )}

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h2>
                {selectedWardrobe
                  ? "Edit Wardrobe Item"
                  : "Add New Wardrobe Item"}
              </h2>
              <span className="close" onClick={closeModal}>
                &times;
              </span>
            </div>
            <form onSubmit={handleSubmit}>
              {/* Basic fields */}
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="image">Image URL</label>
                <input
                  type="text"
                  id="image"
                  name="image"
                  required
                  value={image}
                  onChange={(e) => setImage(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="brand">Brand</label>
                <input
                  type="text"
                  id="brand"
                  name="brand"
                  value={brand}
                  onChange={(e) => setBrand(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="description">Description</label>
                <textarea
                  id="description"
                  name="description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
              {/* Additional fields */}
              <div className="form-group">
                <label htmlFor="wardrobeState">State</label>
                <input
                  type="text"
                  id="wardrobeState"
                  name="wardrobeState"
                  value={wardrobeState}
                  onChange={(e) => setWardrobeState(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="primaryColorName">Primary Color Name</label>
                <input
                  type="text"
                  id="primaryColorName"
                  name="primaryColorName"
                  value={primaryColorName}
                  onChange={(e) => setPrimaryColorName(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="primaryColorCode">Primary Color Code</label>
                <input
                  type="text"
                  id="primaryColorCode"
                  name="primaryColorCode"
                  value={primaryColorCode}
                  onChange={(e) => setPrimaryColorCode(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="secondaryColorName">Secondary Color Name</label>
                <input
                  type="text"
                  id="secondaryColorName"
                  name="secondaryColorName"
                  value={secondaryColorName}
                  onChange={(e) => setSecondaryColorName(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="secondaryColorCode">Secondary Color Code</label>
                <input
                  type="text"
                  id="secondaryColorCode"
                  name="secondaryColorCode"
                  value={secondaryColorCode}
                  onChange={(e) => setSecondaryColorCode(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="size">Size</label>
                <input
                  type="text"
                  id="size"
                  name="size"
                  value={size}
                  onChange={(e) => setSize(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="dateOfPurchase">Date Of Purchase</label>
                <input
                  type="date"
                  id="dateOfPurchase"
                  name="dateOfPurchase"
                  value={dateOfPurchase}
                  onChange={(e) => setDateOfPurchase(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="price">Price</label>
                <input
                  type="text"
                  id="price"
                  name="price"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="printStyle">Print Style</label>
                <input
                  type="text"
                  id="printStyle"
                  name="printStyle"
                  value={printStyle}
                  onChange={(e) => setPrintStyle(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="textureStyle">Texture Style</label>
                <input
                  type="text"
                  id="textureStyle"
                  name="textureStyle"
                  value={textureStyle}
                  onChange={(e) => setTextureStyle(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="collarStyle">Collar Style</label>
                <input
                  type="text"
                  id="collarStyle"
                  name="collarStyle"
                  value={collarStyle}
                  onChange={(e) => setCollarStyle(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="sleeveLength">Sleeve Length</label>
                <input
                  type="text"
                  id="sleeveLength"
                  name="sleeveLength"
                  value={sleeveLength}
                  onChange={(e) => setSleeveLength(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="instructions">
                  Instructions (comma separated)
                </label>
                <input
                  type="text"
                  id="instructions"
                  name="instructions"
                  value={instructions}
                  onChange={(e) => setInstructions(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="tags">Tags (comma separated)</label>
                <input
                  type="text"
                  id="tags"
                  name="tags"
                  value={tags}
                  onChange={(e) => setTags(e.target.value)}
                />
              </div>
              {/* <div className="form-group">
                <label htmlFor="occasion">Occasion</label>
                <input type="text" id="occasion" name="occasion" value={occasion} onChange={(e) => setOccasion(e.target.value)} />
              </div> */}
              <div className="form-group">
                <label htmlFor="wearingSeason">
                  Wearing Season (comma separated)
                </label>
                <input
                  type="text"
                  id="wearingSeason"
                  name="wearingSeason"
                  value={wearingSeason}
                  onChange={(e) => setWearingSeason(e.target.value)}
                />
              </div>
              {/* Select options for Category and Subcategory */}
              <div className="form-group">
                <label htmlFor="categoryId">Category</label>
                <select
                  id="categoryId"
                  name="categoryId"
                  value={categoryId}
                  onChange={(e) => setCategoryId(e.target.value)}
                >
                  <option value="">Select Category</option>
                  {categories.map((cat) => (
                    <option key={cat._id} value={cat._id}>
                      {cat.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="subcategoryId">Sub Category</label>
                <select
                  id="subcategoryId"
                  name="subcategoryId"
                  value={subcategoryId}
                  onChange={(e) => setSubcategoryId(e.target.value)}
                >
                  <option value="">Select Sub Category</option>
                  {subCategories.map((sub) => (
                    <option key={sub._id} value={sub._id}>
                      {sub.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="occasion">Occasion</label>

                <select
                  id="occasion"
                  name="occasion"
                  value=""
                  onChange={(e) => {
                    const value = e.target.value;
                    if (!value) return; // skip placeholder

                    setOccasion(
                      (prev) => (prev.includes(value) ? prev : [...prev, value]) // avoid duplicates
                    );
                  }}
                >
                  <option value="">Select Occasion</option>
                  {userOccasion.map((sub) => (
                    <option key={sub._id} value={sub._id}>
                      {sub.name}
                    </option>
                  ))}
                </select>

                {/* Show selected occasions */}
                <div style={{ marginTop: "8px" }}>
                  {occasion.length > 0 &&
                    occasion.map((id) => {
                      const occ = userOccasion.find((o) => o._id === id);
                      return (
                        <span
                          key={id}
                          onClick={() =>
                            setOccasion((prev) =>
                              prev.filter((occId) => occId !== id)
                            )
                          }
                          style={{
                            padding: "4px 8px",
                            background: "#eee",
                            borderRadius: "6px",
                            marginRight: "6px",
                            display: "inline-block",
                            cursor: "pointer",
                          }}
                        >
                          {occ?.name} ✖
                        </span>
                      );
                    })}
                </div>
              </div>

              <div className="modal-actions">
                <button
                  type="button"
                  className="cancel-button"
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <button type="submit" className="submit-button">
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Hidden file input for bulk upload */}
      <input
        type="file"
        ref={fileInputRef}
        multiple
        accept="image/jpeg,image/jpg,image/png,image/webp,image/heic,.jpg,.jpeg,.png,.webp,.heic"
        onChange={handleFileSelection}
        style={{ display: "none" }}
      />

      <BulkUploadStatusModal
        isOpen={uploadingModal}
        onClose={handleCloseUploadingModal}
        isLoading={isLoading}
        uploadedItems={uploadedData}
        onUpdateItem={handleUpdateUploadedItem}
        onSaveAll={handleSaveAllUploadedItems}
        categories={categories}
        subCategories={subCategories}
        colorMapping={ColorMapping}
        seasonOptions={["Summer", "Winter", "Spring", "Autumn", "Monsoon"]}
        isSaving={isSaving}
        setIsSaving={setIsSaving}
        preference={userData?.stylePreference}
      />
    </div>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      stopLoadingRequest: actions.loader.stopLoading,
      startLoadingRequest: actions.loader.startLoading,
      activateModal: actions.modal.activateModal,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(WardrobePage);
